import React from 'react';
import StyledText from 'components/Helpers/StyledText/StyledText';

const Text = props => {
  const style = require('./Text.scss');
  const { children, innerStyle } = props;

  const wrapperClass = style.textwrapper;
  ///const wrapperClass = innerStyle ? style.basewrapper : style.textwrapper;

  return (
    <p className={wrapperClass}>
      {innerStyle ?
        <span className={innerStyle}>
         <StyledText>{children}</StyledText>
        </span>
      :
        <StyledText>{children}</StyledText>
      }
    </p>
  );
};




export default Text;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Text/Text.js
 **/